// AllIndividualReport.js
// Component for the All Individual Orders Report

// Imports
import React from 'react';
import ReportCard from './ReportCard';
import OrderSelect from './OrderSelect';
import dateFormat from 'dateformat';
import PropTypes from 'prop-types';
import DateInput from './DateInput';

// Component Class
// Shows All Individual Orders Report Card
class AllIndividualReport extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      order: null,
      delivery: dateFormat(new Date(), "dd/mm/yyyy"),
    }
  }
  
  // Returns the filename for the downloaded report
  getFilename = () => {
    var order = this.state.order;
    var date = order && order.dateClosed ? new Date(order.dateClosed) : new Date();
    var dateStr = dateFormat(date, "yyyy.mm.dd");
    return "Carlinhos_Notas_"+dateStr+".pdf"
  }

  // Returns the processed report object
  getReport = () => {
    return this.props.report.getAllOrdersReport(this.state.order, this.state.delivery);
  }

  // Sets the current order to generate reports for
  setOrder = (order) => {
    this.setState({order: order});
  }

  // Sets the target delivery date
  setDelivery = (date) => {
    this.setState({delivery: date !== "" ? date : null})
  }

  // Renders Component
  render() {
    return (
      <ReportCard
        title="Todos os Pedidos Individuais"
        description="Todos os pedidos individuais em uma data, compilados em um único arquivo."
        getReport={this.getReport}
        getFilename={this.getFilename}
      >
        <center>
          <OrderSelect
            orders={this.props.orders}
            selected={this.state.order}
            setOrder={this.setOrder}
          />
          <br />
          <br />
          <DateInput
            setDate={this.setDelivery}
            date={this.state.delivery}
          />
        </center>
        <br />
      </ReportCard>
    );
  }
}

// Required Properties
AllIndividualReport.propTypes = {
  report: PropTypes.object.isRequired,
  orders: PropTypes.object.isRequired,
}

// Exports
export default AllIndividualReport;


// WEBPACK FOOTER //
// ./src/components/ReportView/AllIndividualReport.js